import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button } from '#pplx/frontend/aether/components/Button/index.js';
import { useWebVoiceContext } from '#pplx/frontend/apps/ask/multimodal/voice/launcher/WebVoiceContext.js';
import { Size } from '#pplx/frontend/components/types/types.js';
import { $icon } from '#pplx/frontend/icons/icon-sprite.js';
import React, { useCallback, useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
export const DictationButton = React.memo(function DictationButton({ isInitializing, startTranscription, error = null, disabled = false, pill = false, }) {
    const { $t } = useIntl();
    const isVoiceActive = useWebVoiceContext()?.isActive ?? false;
    const [isInitializingInternal, setIsInitializingInternal] = useState(isInitializing);
    const handleStartTranscription = useCallback(() => {
        // there is a delay between starting transcription and the transcription
        // being initialized. We want to show a loading state until the transcription
        // is initialized.
        setIsInitializingInternal(true);
        startTranscription?.();
    }, [startTranscription]);
    useEffect(() => {
        if (error) {
            setIsInitializingInternal(false);
        }
    }, [error]);
    return (_jsx("div", { className: "relative", children: _jsx(Button, { "aria-label": $t({
                defaultMessage: 'Dictation',
                description: 'Aria label for the dictation button to start voice transcription',
                id: '177dd2edd7',
            }), icon: $icon('microphone'), isLoading: isInitializing || isInitializingInternal, variant: "text", onClick: handleStartTranscription, disabled: disabled || isVoiceActive, size: Size.small, rounded: pill }) }));
});
export const DictationStopButton = React.memo(function DictationStopButton({ stopTranscription, pill = false }) {
    const { $t } = useIntl();
    return (_jsx("div", { className: "relative", children: _jsx(Button, { "aria-label": $t({
                defaultMessage: 'Stop dictation',
                description: 'Aria label for the button to stop voice dictation',
                id: '16886108db',
            }), icon: $icon('player-stop-filled'), variant: "tonal", onClick: stopTranscription, disabled: false, size: Size.small, rounded: pill }) }));
});
export const DictationSubmitButton = React.memo(function DictationSubmitButton({ onSubmit, isDisabled = false, toolTip, pill = false, }) {
    const { $t } = useIntl();
    return (_jsxs("div", { className: "relative", children: [_jsx("div", { className: "bg-super-soft absolute inset-[10%] animate-[ping_1.5s_cubic-bezier(0,0,0.2,1)_infinite] rounded-full" }), _jsx(Button, { "aria-label": toolTip ||
                    $t({
                        defaultMessage: 'Submit dictation',
                        description: 'Aria label for the button to submit the dictated text',
                        id: '9803f806ca',
                    }), icon: $icon('check'), variant: "primary", onClick: onSubmit, disabled: isDisabled, size: Size.small, rounded: pill })] }));
});
//# sourceMappingURL=Dictation.js.map